import React from 'react';
import { Edit, SimpleForm, useRecordContext, useTranslate } from 'react-admin';
import { Alert } from '@mui/material';
import { USER_ROLE_TO_INT } from '@/config/constants';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { UserFields } from './UserFields';

const BACK_TO = '/system?tab=users';

interface UserFormValues {
  id: string;
  name: string;
  email: string;
  role: string | number;
}

// Backend's UserRequestModel expects `role` as int. The form holds it as the
// enum string ("Administrator", "AdvancedUser", "User"), so map before submit.
const transform = (data: UserFormValues) => ({
  id: data.id,
  name: data.name,
  email: data.email,
  role: typeof data.role === 'number' ? data.role : (USER_ROLE_TO_INT[data.role] ?? 3),
});

const InheritedRolesNotice = () => {
  const record = useRecordContext();
  const t = useTranslate();
  if (!record?.hasInheritedRoles) return null;
  return <Alert severity="warning" sx={{ width: '100%' }}>{t('screens.users.inheritedNotice')}</Alert>;
};

export const UserEdit = () => (
  <Edit mutationMode="pessimistic" transform={transform} redirect={BACK_TO} actions={<FormPageTitle mode="edit" />}>
    <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} showDelete />}>
      <InheritedRolesNotice />
      <UserFields mode="edit" />
    </SimpleForm>
  </Edit>
);
